import React, { useState, useEffect, Fragment } from "react";
import { Row, Card, CardBody } from "reactstrap";
import BreadcrumbLink from "../../../components/Common/BreadcrumbLink";
import i18n from "../../../i18n";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Instructions from "./Instructions";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";

const ReassignService = (props) => {
  const dispatch = useDispatch();

  const [step, setStep] = useState(1);
  const [services, setServices] = useState([]);
  const [servicesError, setServicesError] = useState(false);
  const [infoUser, setInfoUser] = useState({ is_staff: false, permissions: [] });
  const [note, setNote] = useState("");
  const [isNoteValid, setIsNoteValid] = useState(false);

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data,
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);

  useEffect(() => {
    if (data?.data) {
      setInfoUser(data.data);
    }
  }, [dispatch, data, loading]);

  const switchStep = () => {
    switch (step) {
      case 1:
        return (
          <Step1
            setStep={setStep}
            step={step}
            infoUser={infoUser}
            setInfoUser={setInfoUser}
            setServices={setServices}
            services={services}
            token={token}
            setServicesError={setServicesError}
            note={note}
            setNote={setNote}
            setIsNoteValid={setIsNoteValid}
            isNoteValid={isNoteValid}
          />
        );
      case 2:
        return (
          <Step2
            setStep={setStep}
            step={step}
            infoUser={infoUser}
            setInfoUser={setInfoUser}
            setServices={setServices}
            services={services}
            token={token}
            servicesError={servicesError}
            setServicesError={setServicesError}
            note={note}
            setNote={setNote}
            setIsNoteValid={setIsNoteValid}
            isNoteValid={isNoteValid}
          />
        );
      default:
        break;
    }
  };

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadcrumbLink
            title={i18n.t("Services")}
            link="/services/assignment"
            breadcrumbItem={i18n.t("Assignment")}
          />
          <Row>
            <Card>
              <CardBody>
                <Instructions step={step} />
              </CardBody>
            </Card>
          </Row>
          <div className="container-fluid">
            <Row>
              <Card>{switchStep()}</Card>
            </Row>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ReassignService;
